import { render, staticRenderFns } from "./BillingTransactionsTruckingTab.vue?vue&type=template&id=4b0c3e00&scoped=true"
import script from "./BillingTransactionsTruckingTab.vue?vue&type=script&lang=js"
export * from "./BillingTransactionsTruckingTab.vue?vue&type=script&lang=js"
import style0 from "./BillingTransactionsTruckingTab.vue?vue&type=style&index=0&id=4b0c3e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c3e00",
  null
  
)

export default component.exports